import * as React from "react";
import Routes from "../../components/Routes";
import tables from "../../routes/tables";

export default () => {
  return <Routes routes={tables} />;
};
